export default {
  data() {
    return {
      numericErrors: {},
    }
  },
  created() {
    this._numericTimers = {}
  },
  methods: {
    numericState(key) {
      return this.numericErrors[key] ? false : null
    },
    numericFeedback(key) {
      return this.numericErrors[key] || ''
    },
    blockNonNumericKeys(event, integerOnly) {
      const blocked = integerOnly
        ? ['e', 'E', '+', '-', '.']
        : ['e', 'E', '+']
      if (blocked.includes(event.key)) event.preventDefault()
    },
    validateNumeric(key, value, min, max, integerOnly) {
      if (this._numericTimers[key]) clearTimeout(this._numericTimers[key])
      if (!this._numericPendingArgs) this._numericPendingArgs = {}
      this._numericPendingArgs[key] = { value, min, max, integerOnly }
      this._numericTimers[key] = setTimeout(() => {
        if (this._numericPendingArgs) delete this._numericPendingArgs[key]
        if (value === '' || value === null || value === undefined) {
          this.$set(this.numericErrors, key, '')
          return
        }
        const num = Number(value)
        if (isNaN(num)) {
          this.$set(this.numericErrors, key, `Must be a number (${min} – ${max})`)
        } else if (integerOnly && !Number.isInteger(num)) {
          this.$set(this.numericErrors, key, `Must be a whole number (${min} – ${max})`)
        } else if (num < min || num > max) {
          this.$set(this.numericErrors, key, `Must be between ${min} and ${max}`)
        } else {
          this.$set(this.numericErrors, key, '')
        }
      }, 1000)
    },
    hasNumericErrors() {
      return Object.values(this.numericErrors).some(e => !!e)
    },
    firstNumericErrorKey() {
      return Object.keys(this.numericErrors).find(k => !!this.numericErrors[k])
    },
    flushNumericValidation() {
      if (!this._numericPendingArgs) this._numericPendingArgs = {}
      Object.keys(this._numericTimers || {}).forEach(key => {
        clearTimeout(this._numericTimers[key])
        delete this._numericTimers[key]
      })
      Object.entries(this._numericPendingArgs).forEach(([key, { value, min, max, integerOnly }]) => {
        if (value === '' || value === null || value === undefined) {
          this.$set(this.numericErrors, key, '')
          return
        }
        const num = Number(value)
        if (isNaN(num)) {
          this.$set(this.numericErrors, key, `Must be a number (${min} – ${max})`)
        } else if (integerOnly && !Number.isInteger(num)) {
          this.$set(this.numericErrors, key, `Must be a whole number (${min} – ${max})`)
        } else if (num < min || num > max) {
          this.$set(this.numericErrors, key, `Must be between ${min} and ${max}`)
        } else {
          this.$set(this.numericErrors, key, '')
        }
      })
      this._numericPendingArgs = {}
    },
    scrollToFirstNumericError() {
      const key = this.firstNumericErrorKey()
      if (!key) return

      let toggleKey = null
      if (this.jsonFieldToggleMap && this.jsonFieldToggleMap[key]) {
        toggleKey = this.jsonFieldToggleMap[key]
      }
      if (!toggleKey && this.fieldPrefixSectionMap) {
        for (const [prefix, sectionKey] of this.fieldPrefixSectionMap) {
          if (key.startsWith(prefix)) { toggleKey = sectionKey; break }
        }
      }

      const sectionWasClosed = toggleKey && this.toggle && !this.toggle[toggleKey]
      if (toggleKey && this.toggle !== undefined) this.$set(this.toggle, toggleKey, true)
      const delay = sectionWasClosed ? 420 : 0

      this.$nextTick(() => setTimeout(() => {
        const row = this.$el.querySelector(`[data-field="${key}"]`)
        const scrollTarget = row || this.$el
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' })
        let highlightEls
        if (row && row.tagName === 'TR') {
          const input = row.querySelector('input, select, textarea, .custom-select')
          highlightEls = input ? [input] : Array.from(row.querySelectorAll('td, th'))
        } else {
          highlightEls = [scrollTarget]
        }
        highlightEls.forEach(el => {
          el.style.transition = 'none'
          el.style.backgroundColor = '#fff3cd'
          el.style.outline = '2px solid #ffc107'
        })
        setTimeout(() => {
          highlightEls.forEach(el => {
            el.style.transition = 'background-color 1.5s ease-out, outline-color 1.5s ease-out'
            el.style.backgroundColor = ''
            el.style.outlineColor = 'transparent'
          })
          setTimeout(() => highlightEls.forEach(el => { el.style.transition = ''; el.style.outline = '' }), 1600)
        }, 800)
      }, delay))
    },
  },
  watch: {
    loading(newVal) {
      if (newVal) {
        this.numericErrors = {}
        if (this._numericTimers) {
          Object.values(this._numericTimers).forEach(t => clearTimeout(t))
          this._numericTimers = {}
        }
        this._numericPendingArgs = {}
      }
    }
  },
  beforeDestroy() {
    if (this._numericTimers) {
      Object.values(this._numericTimers).forEach(t => clearTimeout(t))
    }
  }
}
